const ABORTION_ERROR: string = "AbortError";

declare global {
  interface Location {
    href: string;
  }
}

const timeOutResponseProps: {
  status: number;
  statusText: string;
} = {
  status: 408,
  statusText: "Timeout Request",
};

/**
 * fetchWithTimeout utility function made for aborting the fetch
 * native function if the request takes more then 10 seconds.
 * Inspired from https://dmitripavlutin.com/timeout-fetch-request/
 *
 * @param url = String to be called by window.fetch function
 * @param options = additional options
 * @param timeOut = milliseconds number for fetch timeOut, 40000 (40 sec) by default
 * @returns Promise in case if it fits the timeout limit or void if
 * we do abort the connection on purpose.
 */
const fetchWithTimeout = async (
  url: string,
  options: any = {},
  timeOut: number = 40000
): Promise<Response> => {
  const timeOutBody: string = JSON.stringify({
    fullUrl: typeof window !== "undefined" ? `${location.href}/${url}` : url,
  });
  const controller: AbortController = new AbortController();
  const { signal } = controller;

  // Timeout duration in milliseconds (40 seconds)
  const timeoutId: NodeJS.Timeout = setTimeout(
    () => controller.abort(),
    timeOut
  );

  return new Promise((resolve, reject) => {
    fetch(url, { ...options, signal })
      .then((response: Response) => {
        clearTimeout(timeoutId);
        return resolve(response);
      })
      .catch((err: any) => {
        if (err.name === ABORTION_ERROR) {
          const timeoutResponse = new Response(
            timeOutBody,
            timeOutResponseProps
          );
          resolve(timeoutResponse);
        } else {
          clearTimeout(timeoutId);
          reject(err);
        }
      });
  });
};

export default fetchWithTimeout;
